import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { useTranslation } from 'react-i18next';
import PersonIcon from '@mui/icons-material/Person';
import { useState } from 'react';
import { UserProfile, UserSelector } from '@features/users';
import { useDispatch } from 'react-redux';
import { patchTestRunResultsRequest } from '../store';

const TestrunResultAssigneeDialog = ({ testrunId, selectedTestRunResultsObjects, disabled }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [openAssigneeModal, setOpenAssigneeModal] = useState(false);
    const [userId, setUserId] = useState(null);
    const data = { assigned_user: userId };
    const handleOpenModal = () => {
        if (selectedTestRunResultsObjects.length > 1) {
            setUserId(null);
        } else {
            const assigned = selectedTestRunResultsObjects[0]?.assigned_user ?? null;
            setUserId(assigned);
        }

        setOpenAssigneeModal(true);
    };
    const handleCloseModal = () => setOpenAssigneeModal(false);

    const handleAssigneeUser = () => {
        dispatch(
            patchTestRunResultsRequest({
                testrunId,
                results: selectedTestRunResultsObjects,
                data,
            }),
        );
        handleCloseModal();
        setUserId(null);
    };

    return (
        <Box>
            <UtmsButton disabled={disabled} startIcon={<PersonIcon />} onClick={handleOpenModal}>
                {t('assignee_to_user')}
            </UtmsButton>

            <Dialog slotProps={{ paper: { sx: { width: '400px' } } }} maxWidth={false} open={openAssigneeModal}>
                <DialogTitle variant="h4">{t('assignee_to_user')}</DialogTitle>

                <DialogContent>
                    <UserSelector
                        sx={{ width: '100%' }}
                        value={userId}
                        onChange={(_event, newOption) => {
                            if (newOption) {
                                setUserId(newOption.pk);
                            } else {
                                setUserId(null);
                            }
                        }}
                        renderOption={(props, option) => (
                            <UserProfile
                                key={option.pk}
                                createdUserId={option.pk}
                                showAvatar
                                userContainerProps={{
                                    sx: {
                                        border: 'none',
                                        gap: '2px',
                                        margin: 0,
                                        width: '100%',
                                    },
                                    ...props,
                                }}
                            />
                        )}
                        TextFieldProps={{
                            variant: 'standard',
                            label: null,
                        }}
                        inputHeight={34}
                    />
                </DialogContent>

                <DialogActions>
                    <UtmsButton onClick={handleAssigneeUser}>{t('apply')}</UtmsButton>
                    <UtmsButton color="secondary" onClick={handleCloseModal}>
                        {t('close')}
                    </UtmsButton>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default TestrunResultAssigneeDialog;
